









































































































































































import Vue from 'vue';
import store from '../store';
import { routeEnterHelper } from '../helpers';

export default Vue.extend({
    computed: {
        pages() {
            return store.state.pages;
        },
        product() {
            return store.state.product;
        },
        optionBlocks() {
            const productOptions: Array<{
                id: string,
                attribute: string,
                option: string,
            }> = [];
            if (store.state.product) {
                const po = store.state.product.options;
                store.state.attributes.forEach((attribute, key) => {
                    const optionId = String(po[attribute.id]);
                    const option = (optionId && attribute.options.find((o) => o.id === optionId)) || null;

                    if (option && option.label && option.articleNo !== '---') {
                        productOptions.push({
                            id: (option && option.id) || attribute.id,
                            attribute: attribute.label,
                            option: (option && option.label),
                        });
                    }
                });
            }

            const pagingSize = Math.max(1, Math.floor((productOptions.length + 1) / 2));
            const blocks2 = [];
            for (let i = 0; i < productOptions.length; i += pagingSize) {
                blocks2.push({
                    productOptions: productOptions.slice(i, i + pagingSize),
                    id: i + '_' + pagingSize,
                });
            }
            return {
                blocks1: [{
                    productOptions,
                    id: '1',
                }],
                blocks2,
            };
        },
        homePage() {
            return store.getters.homePage;
        },
        compare() {
            return store.state.compare;
        },
        assumeEmptyProduct() {
            return store.state.flags.assumeemptyproduct === true;
        },
        kit() {
            if (this.assumeEmptyProduct) {
                const kit: {
                    name: string,
                    subtitle: string,
                    articleNo: string,
                    description: string,
                    image: string | null,
                    datasheet: string | null,
                    more: any[],
                } = {
                    name: '',
                    subtitle: '',
                    articleNo: '',
                    description: '',
                    image: null,
                    datasheet: null,
                    more: [],
                };
                if (store.state.product) {
                    const po = store.state.product.options;
                    store.state.attributes.forEach((attribute, key) => {
                        const optionId = String(po[attribute.id]);
                        const option = (optionId && attribute.options.find((o) => o.id === optionId)) || null;

                        if (option && option.label && option.articleNo !== '---') {
                            if (option.articleNo) {
                                if (!kit.name) {
                                    kit.name = option.name || option.articleNo;
                                    kit.subtitle = option.subtitle || '';
                                    kit.articleNo = option.articleNo;
                                    kit.description = option.description || '';
                                    kit.image = option.image;
                                    kit.datasheet = option.datasheet;
                                } else {
                                    if (option.description) {
                                        kit.more.push({
                                            id: option.articleNo,
                                            name: option.name || option.articleNo,
                                            subtitle: option.subtitle || '',
                                            articleNo: option.articleNo,
                                            description: option.description || '',
                                            image: option.image,
                                            datasheet: option.datasheet,
                                        });
                                    }
                                }
                            }
                        }
                    });
                }

                if (kit.name) {
                    return kit;
                }
            }
        },
    },
    methods: {
        productForOrder() {
            store.dispatch('productForOrder', { product: this.product} ).then(() => {
                this.$router.push({ name: 'order'});
            });
        },
        addCompareProduct() {
            store.dispatch('addCompareProduct', { product: this.product} ).then(() => {
                this.$router.push({ name: 'compare'});
            });
        },
    },
    beforeRouteEnter(to, from, next) {
        routeEnterHelper(store.state.product != null, from, next);
    },
});
